export default (state, action) => {
  return JSON.parse(JSON.stringify(action));
};
